import { GetCurrentCarPlaceInfoInput } from '../../../API';
import { GetCurrentCarPlaceQuery, QueryOutputType } from '../../../common/type/QueryType';
import { graphqlOperationWithTokenRefresh } from '../../../common/api/graphqlOperation';

/**
 * 車両現在位置一覧取得用のクエリ
 */
const query = /* GraphQL */ `
	query GetCurrentCarPlace($offsegInput: GetCurrentCarPlaceInfoInput!, $g500LiteInput: GetCurrentCarPlaceInfoInput!) {
		getOffsegCurrentCarPlaceInfo(input: $offsegInput) {
			responseType
			message
			currentCarPlaceInfoList {
				organizeName
				carCode
				numberPlate
				driverName
				connectionStatus
				receiveDatetime
				lat
				lon
			}
		}
		getG500LiteCurrentCarPlaceInfo(input: $g500LiteInput) {
			responseType
			message
			currentCarPlaceInfoList {
				organizeName
				carCode
				numberPlate
				driverName
				connectionStatus
				receiveDatetime
				lat
				lon
			}
		}
	}
`;

/**
 * 車両現在位置一覧取得APIを呼び出す
 */
export const queryGetCurrentCarPlace = async (
	offsegInput: GetCurrentCarPlaceInfoInput,
	g500LiteInput: GetCurrentCarPlaceInfoInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetCurrentCarPlaceQuery>> => {
	const apiResponse = await graphqlOperationWithTokenRefresh<GetCurrentCarPlaceQuery>(
		query,
		{ offsegInput: offsegInput, g500LiteInput: g500LiteInput },
		authorizationToken,
	);
	console.log(apiResponse);

	return apiResponse;
};
